// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.default-message[data-v-226b3056] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
